module.exports = "<!-- <app-score></app-score> -->\n<app-canvas></app-canvas>\n"


//////////////////
// WEBPACK FOOTER
// /Users/ColeMarsteller/learn-js/Mehtris/src/app/app.component.html
// module id = ../../../../../src/app/app.component.html
// module chunks = main